import { useSyncExternalStore } from 'react';
import {
  clearActiveContext,
  getActiveContext,
  setActiveSyrveConnection,
  setActiveContext,
  clearActiveSyrveConnection,
  subscribeToActiveContext,
  type ActiveContextState,
} from '@/shared/activeContext';

export function useActiveContext() {
  const activeContext = useSyncExternalStore(subscribeToActiveContext, getActiveContext, getActiveContext);
  return {
    activeContext,
    setActiveContext,
    clearActiveContext,
    setActiveSyrveConnection,
    clearActiveSyrveConnection,
  };
}

export type { ActiveContextState };
